export default __webpack_public_path__ + "static/tanushree-a8f4a8d7bde11cccf236461ab2ead5bf.png";